import React, { useState } from 'react';
import { hallitems } from '../Data';
import { eventitems } from '../Data';
import { tripitems } from '../Data';
import Studio from './Studio';
import styles from './classes.module.css';

const Classes = () => {
    const [state] = useState([
        {
            id: "GoToClasses",
            header: "Studio",
            collection: hallitems,
            align: "right", // Image Left, Text Right visually based on new CSS flex-direction mapping
            requireHeading: "WHAT SHOULD I BRING WITH ME?",
            requirements: "A yoga mat if you do not have one, you can buy one at the studio.If you sweat a lot, bring a towel and some water.Wear comfortable clothes",
            para: "We have well furnished hall equipped with all the instruments required to perform yoga and Sound system to conduct classes to provide you a rich experience."
        },
        {
            id: "GoToEvents",
            header: "Events",
            collection: eventitems,
            align: "left", // Text Left, Image Right visually
            requirements: "",
            requireHeading: "",
            para: "At Yogsadhna, we conduct expert lecturers to guide you through the journey. Dr.Varsha Apte enlightened us on how yoga can defeat diabetics. They Shared knowledge about some tasty diet plans that can help you maintain your physique."
        },
        {
            id: "GoToTrips",
            header: "Trips",
            align: "right",
            collection: tripitems,
            requirements: "",
            requireHeading: "",
            para: "Its not just exercise that keeps you healthy and happy. Everyone needs a vacation now and then to refresh and energize for everyday work. At Yogsadhna we had a lot of such trips to Bhandardara, Goshala near Aurangabad, Gogababa and many more. Its like a family trip, everyone contributes in organizing the trip which makes it a lot more fun."
        }
    ]);

    const navitem = state.map(item => (
        <Studio
            key={item.id}
            align={item.align}
            requireHeading={item.requireHeading}
            requirements={item.requirements}
            id={item.id}
            header={item.header}
            para={item.para}
            collection={item.collection}
        />
    ));

    return (
        <div className={styles.classesMasterContainer}>
            {navitem}
        </div>
    );
}
export default Classes;
